module.exports = __webpack_public_path__ + "img/noQrcode.050bf6d6.png";